import React, { Component } from 'react'
import { Avatar, Badge, Dropdown, Menu, Icon } from 'antd' // 👈 Icon imported here
import { connect } from 'react-redux'
import { MenuIcon, SearchIcon, BellIcon } from './Icons'
import { getPushPathWrapper } from '../../../routes'

// Import your article search API (Make sure this path is correct for your folders!)
import { ArticleSearchById } from '../../article/actions'

const boxStyle = {
  width: 40,
  height: 40,
  border: '1px solid #e4eae7',
  borderRadius: 10,
  background: '#ffffff',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#45524c',
  cursor: 'pointer'
}

const avatarStyle = {
  width: 39,
  height: 39,
  minWidth: 39,
  borderRadius: 11,
  backgroundColor: '#eaf4ef',
  color: '#1f6b4f',
  fontWeight: 850,
  fontSize: 13,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: '39px'
}

class TopHeader extends Component {
  state = {
    searchText: ''
  }

  handleToggle = () => {
    this.props.dispatch({ type: 'TOGGLE_SIDEBAR_COLLAPSED' })
  }

  handleLogout = () => {
    this.props.dispatch({ type: 'LOGOUT' })
  }

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value })
  }

  handleSearchSubmit = async (e) => {
    if (e.key === 'Enter' && this.state.searchText.trim() !== '') {
      const articleNo = this.state.searchText.trim();

      // Call the exact same API your old component used
      let { success, data } = await ArticleSearchById({ articleNo });

      if (success) {
        // Push the route using the real database _id
        this.props.dispatch(getPushPathWrapper('articleView', { id: data._id }));

        // Refresh article store exactly like your old code did
        this.props.dispatch({ type: 'REFRESH_ARTICLE', refreshArticle: true });

        // Clear the search box
        this.setState({ searchText: '' });
      } else {
        // If not found, just clear the box
        this.setState({ searchText: '' });
      }
    }
  }

  render() {
    const user = JSON.parse(localStorage.getItem('user')) || {}
    const name = user.name || 'ARCC Admin'
    const role = user.role || 'Super Administrator'
    const initials = name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()

    // 👇 Professional Antd Pro style menu with Icons and Divider
    const userMenu = (
      <Menu style={{ minWidth: 160, padding: '5px 0', borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <Menu.Item key="profile" disabled style={{ cursor: 'default' }}>
          <Icon type="user" style={{ marginRight: 10 }} />
          <span>Logged in as {role}</span>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="logout" onClick={this.handleLogout}>
          <div style={{ color: '#ff4d4f', display: 'flex', alignItems: 'center' }}>
            <Icon type="logout" style={{ marginRight: 10, fontSize: 15 }} />
            <span style={{ fontWeight: 500 }}>Log out</span>
          </div>
        </Menu.Item>
      </Menu>
    )

    return (
      <div className={'topHeaderBar'}>
        <div className={'topHeaderLeft'}>
          <span style={boxStyle} onClick={this.handleToggle}>
            <MenuIcon style={{ width: 19, height: 19 }} />
          </span>
          <div className={'topHeaderSearch'}>
            <SearchIcon className={'topHeaderSearchIcon'} style={{ width: 18, height: 18 }} />

            <input
              className={'topHeaderSearchInput'}
              placeholder={'Search article ID...'}
              value={this.state.searchText}
              onChange={this.handleSearchChange}
              onKeyDown={this.handleSearchSubmit}
            />

            <span className={'topHeaderSearchShortcut'}>⌘ K</span>
          </div>
        </div>
        {/*<div className={'topHeaderRight'}>*/}
        {/*  <Badge dot>*/}
        {/*    <span style={{ ...boxStyle, position: 'relative', marginRight: 16 }}>*/}
        {/*      <BellIcon style={{ width: 19, height: 19 }} />*/}
        {/*    </span>*/}
        {/*  </Badge>*/}
        <div className={'topHeaderRight'}>

          {/* 👇 HTML Mockup Style Bell Icon (No Ant Design Badge!) */}
          <span style={{ ...boxStyle, position: 'relative' }}>
            <BellIcon style={{ width: 19, height: 19 }} />
            <span style={{
              position: 'absolute',
              right: 6,
              top: 6,
              width: 9,
              height: 9,
              background: '#ed7b2f', /* Orange accent */
              border: '2px solid white',
              borderRadius: '50%'
            }}></span>
          </span>

          {/* 👇 Grouped Avatar and UserInfo perfectly aligned with a dropdown caret */}
          <Dropdown overlay={userMenu} placement="bottomRight" trigger={['click', 'hover']}>
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '4px 8px', borderRadius: 8 }}>
              <Avatar style={avatarStyle}>{initials}</Avatar>
              <div className={'topHeaderUserInfo'} style={{ marginLeft: 12 }}>
                <div className={'topHeaderUserName'}>{name}</div>
                <div className={'topHeaderUserRole'}>{role}</div>
              </div>
              <Icon type="down" style={{ fontSize: 12, marginLeft: 14, color: '#889891' }} />
            </div>
          </Dropdown>

        </div>
      </div>
    )
  }
}

export default connect()(TopHeader)

